import { render, staticRenderFns } from "./data-click-view.vue?vue&type=template&id=0a2514be&scoped=true&"
import script from "./data-click-view.vue?vue&type=script&lang=js&"
export * from "./data-click-view.vue?vue&type=script&lang=js&"
import style0 from "./data-click-view.vue?vue&type=style&index=0&id=0a2514be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2514be",
  null
  
)

export default component.exports